// src/components/affiliate/CoupangBanner.tsx
import React, { useEffect, useState } from 'react';
import {
    COUPANG_BANNERS,
    COUPANG_DISCLOSURE,
    COUPANG_IFRAME_BANNERS,
    isCoupangEnabled,
    pickCoupangLink,
} from '../../config/coupang';
import CoupangDynamicBanner from './CoupangDynamicBanner';
import Icon from '../common/Icon';

/**
 * 쿠팡 파트너스 배너 (페이지당 1회).
 *
 * 애드센스가 우선이므로 본문 맨 아래, 공식 신청 안내 다음에만 배치합니다.
 *
 * - 넓은 화면: 가로형 728x90 다이나믹 배너
 * - 좁은 화면: 폭 100% iframe 배너 (728px 고정폭은 모바일에서 넘칩니다)
 * - linkSeed 를 주면 배너 아래에 제휴 텍스트 링크가 하나 붙습니다
 *   (같은 페이지에서는 항상 같은 링크)
 *
 * 화면 폭 판정은 마운트 후에 하므로 프리렌더 HTML 과 첫 렌더 결과가 같아
 * hydration 이 깨지지 않습니다.
 */
const WIDE_FROM = 768;

interface CoupangBannerProps {
    className?: string;
    /** 텍스트 링크를 고르는 기준값 (보통 지원금 slug) */
    linkSeed?: string;
}

const CoupangBanner: React.FC<CoupangBannerProps> = ({ className = '', linkSeed }) => {
    const [wide, setWide] = useState(false);

    useEffect(() => {
        const mq = window.matchMedia(`(min-width: ${WIDE_FROM}px)`);
        const sync = () => setWide(mq.matches);
        sync();
        mq.addEventListener('change', sync);
        return () => mq.removeEventListener('change', sync);
    }, []);

    if (!isCoupangEnabled) return null;

    const link = linkSeed ? pickCoupangLink(linkSeed) : null;

    return (
        <div className={`gh-cpang-banner ${className}`}>
            {wide ? (
                <CoupangDynamicBanner banner={COUPANG_BANNERS.wide} />
            ) : (
                <iframe
                    src={COUPANG_IFRAME_BANNERS.wide.src}
                    height={COUPANG_IFRAME_BANNERS.wide.height}
                    width="100%"
                    frameBorder={0}
                    scrolling="no"
                    referrerPolicy="unsafe-url"
                    title="쿠팡 파트너스 추천 상품"
                />
            )}

            {link && (
                <a
                    className="gh-cpang-banner__link"
                    href={link}
                    target="_blank"
                    rel="sponsored nofollow noopener noreferrer"
                >
                    쿠팡에서 보기
                    <Icon name="external" size={13} strokeWidth={2.2} />
                </a>
            )}

            <p className="gh-cpang-banner__notice">{COUPANG_DISCLOSURE}</p>
        </div>
    );
};

export default CoupangBanner;
